import api from "../../config/Api";
import { Wishlist, WishlistState } from "../../types/wishlistTypes";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: WishlistState = {
    wishList: null,
    loading: false,
    error: null,
};

export const getWishlistByUserId = createAsyncThunk(
    "wishlist/getWishlistByUserId",

    async(_, {rejectWithValue}) => {
        try {
            const response = await api.get(`/api/wishlist`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("jwt")}`,
                },
            });
           // console.log("wishlist fetched ", response.data);
            return response.data;
        } catch (error:any) {
           // console.log("error ", error);
            return rejectWithValue(
                error.response?.data.message || "Failed to fetch wishlist"
            );
        }
    }
);

export const AddProductToWishList = createAsyncThunk(
    "wishlist/addProductToWishlist",
    async ({productId}: {productId: number}, {rejectWithValue}) => {
        try {
            const response = await api.post(`/api/wishlist/add-product/${productId}`, {}, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("jwt")}`,
                },
            });
            //console.log("add product ", response.data);
            return response.data;
        }catch (error: any){
            return rejectWithValue(
                error.response?.data.message || "Failed to add product to wishlist"
            );
        }
    }
);

const wishlistSlice = createSlice({
    name: "wishlist",
    initialState,
    reducers: {
        resetWishlistState: (state) => {
            state.wishList = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getWishlistByUserId.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getWishlistByUserId.fulfilled, (state, action: PayloadAction<Wishlist>) => {
            state.wishList = action.payload;
            state.loading = false;
        });
        builder.addCase(getWishlistByUserId.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(AddProductToWishList.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(AddProductToWishList.fulfilled, (state, action: PayloadAction<Wishlist>) => {
            state.wishList = action.payload;
            state.loading = false;
        });
        builder.addCase(AddProductToWishList.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});


export const { resetWishlistState } = wishlistSlice.actions;

export default wishlistSlice.reducer;